import { AxiosRequestConfig } from "axios";

export const CUSTOM_CONFIG_KEY = "_CUSTOM_CONFIG";

export const getCustomConfig = (config: AxiosRequestConfig) => {
  const data = config?.headers?.[CUSTOM_CONFIG_KEY] as string;
  return data ? JSON.parse(data) : undefined;
};
